import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getChallenges,
  getChallenge,
  submitChallengeResponse,
  getChallengeApproach,
  getMyChallengeSubmissions,
} from '../api/challenges-api';

export const useChallenges = () => {
  return useQuery({
    queryKey: ['challenges'],
    queryFn: getChallenges,
  });
};

export const useChallenge = (id) => {
  return useQuery({
    queryKey: ['challenge', id],
    queryFn: () => getChallenge(id),
    enabled: !!id,
  });
};

export const useChallengeApproach = (id, enabled = true) => {
  return useQuery({
    queryKey: ['challenge-approach', id],
    queryFn: () => getChallengeApproach(id),
    enabled: !!id && enabled,
    retry: false,
  });
};

export const useMyChallengeSubmissions = (id) => {
  return useQuery({
    queryKey: ['challenge-submissions', id],
    queryFn: () => getMyChallengeSubmissions(id),
    enabled: !!id,
  });
};

export const useSubmitChallenge = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, response }) => submitChallengeResponse(id, response),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['challenge-submissions', variables.id] });
      queryClient.invalidateQueries({ queryKey: ['challenges'] });
    },
  });
};
